import { useTranslation } from "react-i18next";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import {
  CHART_AXIS_TICK,
  CHART_CURSOR,
  CHART_GRID_STROKE,
  PRIMARY_COLOR,
} from "../constants";
import { ChartCard, CustomChartTooltip } from "./ChartParts";

export interface SalesBarDatum {
  name: string;
  vendas: number;
  amount_formatted: string;
}

interface SalesBarChartCardProps {
  title: string;
  description: string;
  data: SalesBarDatum[];
  isLoading: boolean;
  mobileHeight: number;
  desktopHeight: number;
  /** Mesmas alturas em classe literal, para o Tailwind gerar: "h-[200px] sm:h-[250px]". */
  heightClassName: string;
}

/** Barras de quantidade de vendas por período (hora, dia da semana, mês). */
export function SalesBarChartCard({
  title,
  description,
  data,
  isLoading,
  mobileHeight,
  desktopHeight,
  heightClassName,
}: SalesBarChartCardProps) {
  const { t } = useTranslation("reports");

  return (
    <ChartCard
      title={title}
      description={description}
      isLoading={isLoading}
      isEmpty={data.length === 0}
      heightClassName={heightClassName}
    >
      <ResponsiveContainer
        width="100%"
        height={window.innerWidth < 640 ? mobileHeight : desktopHeight}
      >
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_STROKE} />
          <XAxis dataKey="name" tick={CHART_AXIS_TICK} axisLine={false} tickLine={false} />
          <YAxis tick={CHART_AXIS_TICK} axisLine={false} tickLine={false} />
          <RechartsTooltip content={<CustomChartTooltip />} cursor={CHART_CURSOR} />
          <Bar
            dataKey="vendas"
            name={t("reports:sales_count")}
            fill={PRIMARY_COLOR}
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
